class MarqueeBar extends HTMLElement {
  connectedCallback() {
    if (this.dataset.enabled !== 'true') return;

    this.container = this.parentElement;
    this.baseSets = Array.from(this.children); 

    this.build = this.build.bind(this);
    this.build();

    this._onResize = this.debounce(this.build, 200);
    window.addEventListener('resize', this._onResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._onResize);
  }

  build() {
    Array.from(this.children).forEach((child) => {
      if (!this.baseSets.includes(child)) child.remove();
    });

    const containerWidth = this.container.offsetWidth;
    const firstSet = this.baseSets[0];
    const setWidth = firstSet.getBoundingClientRect().width;

    if (!setWidth || !containerWidth) return;

    let totalWidth = this.getBoundingClientRect().width;
    while (totalWidth < containerWidth * 2) {
      const clone = firstSet.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
      this.appendChild(clone);
      totalWidth += setWidth;
    }

    this.style.setProperty('--marquee-distance', `${setWidth}px`);
  }

  debounce(fn, wait) {
    let timer;
    return () => {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }
}

if (!customElements.get('marquee-bar')) {
  customElements.define('marquee-bar', MarqueeBar);
}